"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsWidgetTableTrendIndicatorEnum = void 0;
var StatsWidgetTableTrendIndicatorEnum;
(function (StatsWidgetTableTrendIndicatorEnum) {
    StatsWidgetTableTrendIndicatorEnum["Data"] = "Data";
    StatsWidgetTableTrendIndicatorEnum["DiffData"] = "DiffData";
    StatsWidgetTableTrendIndicatorEnum["DiffPercentage"] = "DiffPercentage";
    StatsWidgetTableTrendIndicatorEnum["Arrow"] = "Arrow";
    StatsWidgetTableTrendIndicatorEnum["ArrowData"] = "ArrowData";
    StatsWidgetTableTrendIndicatorEnum["ArrowDiffData"] = "ArrowDiffData";
    StatsWidgetTableTrendIndicatorEnum["ArrowDiffPercentage"] = "ArrowDiffPercentage";
    StatsWidgetTableTrendIndicatorEnum["Icon"] = "Icon";
    StatsWidgetTableTrendIndicatorEnum["IconData"] = "IconData";
    StatsWidgetTableTrendIndicatorEnum["IconDiffData"] = "IconDiffData";
    StatsWidgetTableTrendIndicatorEnum["IconDiffPercentage"] = "IconDiffPercentage";
    StatsWidgetTableTrendIndicatorEnum["Background"] = "Background";
})(StatsWidgetTableTrendIndicatorEnum = exports.StatsWidgetTableTrendIndicatorEnum || (exports.StatsWidgetTableTrendIndicatorEnum = {}));
